export const API_URL = import.meta.env.VITE_APP_API_BASE_URL;
export const EDGE_API_URL = import.meta.env.VITE_APP_EDGE_API_URL || API_URL;
export const STATIC_URL = import.meta.env.VITE_APP_STATIC_FILES_BASE_URL || "";
export const PUBLIC_URL = import.meta.env.PUBLIC_URL || "";

export const DEFAULT_BULK_IFRAME = import.meta.env.VITE_APP_BULK_IFRAME_URL;

export const REGION_CHECK_URL = `${EDGE_API_URL}/location`;

export const DATA_ATTRIBUTES_PREFIX = import.meta.env
  .VITE_APP_DATA_ATTRIBUTES_PREFIX;

export const EMBED_ELEMENTS_PREFIX = import.meta.env
  .VITE_APP_EMBED_ELEMENTS_PREFIX;

export const GENERIC_PREFIX =
  import.meta.env.VITE_APP_WHITELABEL_MODE === "true" ? "consent" : "cf";

// WHITELABEL ATTRIBUTES
export const ACCENT_COLOR_ATTR = `${DATA_ATTRIBUTES_PREFIX}-accent-color`;

export const ACCENT_BG_COLOR_ATTR = `${DATA_ATTRIBUTES_PREFIX}-accent-bg-color`;

export const CORNER_STYLE_ATTR = `${DATA_ATTRIBUTES_PREFIX}-corner-style`;

export const OUTLINE_ACCENT_COLOR_ATTR = `${DATA_ATTRIBUTES_PREFIX}-outline-accent-color`;

export const BG_COLOR_ATTR = `${DATA_ATTRIBUTES_PREFIX}-bg-color`;

export const WIDGET_ATTR = `${DATA_ATTRIBUTES_PREFIX}-widget`;

export const BUTTON_ATTR = `${DATA_ATTRIBUTES_PREFIX}-button`;

export const ACTION_ATTR = `${DATA_ATTRIBUTES_PREFIX}-action`;

export const CATEGORY_ATTR = `${DATA_ATTRIBUTES_PREFIX}-category`;

export const CONSENT_COOKIE =
  import.meta.env.VITE_APP_WHITELABEL_MODE === "true"
    ? "visitor-consent"
    : "cookiefirst-consent";

export const VISITOR_ID_COOKIE =
  import.meta.env.VITE_APP_WHITELABEL_MODE === "true"
    ? "consent-id"
    : "cookiefirst-id";

export const LANGUAGE_COOKIE =
  import.meta.env.VITE_APP_WHITELABEL_MODE === "true"
    ? "cookie-banner-lng"
    : "cf-user-lang";

export const TCSTRING_COOKIE =
  import.meta.env.VITE_APP_WHITELABEL_MODE === "true"
    ? "cookie-banner-tcstring"
    : "cf-user-tcstring";

export const JS_API_OBJECT_NAME =
  import.meta.env.VITE_APP_WHITELABEL_MODE === "true"
    ? "ConsentManager"
    : "CookieFirst";

export const APP_VERSION = import.meta.env.VITE_APP_VERSION;

export const LOGS_PREFIX =
  import.meta.env.VITE_APP_WHITELABEL_MODE === "true" ? "[Banner]" : "[CF]";

export const EVENTS_PREFIX =
  import.meta.env.VITE_APP_WHITELABEL_MODE === "true" ? "banner" : "cf";

export const WITHDRAW_COOKIE = "WITHDRAW";
